import { SPACE_KEY } from '../constants/keys';
import handleListInitialization from '../helpers/handle-list-initialization';
import canBeRichEdited from '../../constraints/verifiers/can-be-rich-edited';
import cleanFormatting from '../helpers/clean-formatting';
import isNodesFullySelected from '../verifiers/is-nodes-fully-selected';

const spaceHandler = (e) => {
  if (e.key !== ' ' && e.key !== SPACE_KEY) return;

  const { srcElement } = e;
  const closestContentEditable = srcElement.closest('[contenteditable]');

  if (canBeRichEdited(closestContentEditable)) {
    // we need to clean custom elements such as [ws-decoration, ws-color]
    // to prevent browser native font creation with color on next input
    if (isNodesFullySelected()) {
      cleanFormatting();
    }
    handleListInitialization(e);
  }
};

export default spaceHandler;
